export default __webpack_public_path__ + "static/media/notification.e278e69a.svg";